import { EntityKind } from '../entity/entity-kind.js';
import { createPermission, PermissionRead, PermissionUpdate, PermissionWrite } from '../permission/permissions.js';

export const PermissionReceiverRead = createPermission(EntityKind.Receiver, PermissionRead);
export const PermissionReceiverWrite = createPermission(EntityKind.Receiver, PermissionWrite);
export const PermissionReceiverUpdate = createPermission(EntityKind.Receiver, PermissionUpdate);